import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { Heart } from 'lucide-react';

import { LogoText } from '@/components/logo-text';
import { LoadingState } from '@/components/shared';
import { useUserMe } from '@/hooks/queries/use-user-me';

import { InvitePartnerForm } from './-components/invite-partner-form';

export const Route = createFileRoute('/(app)/onboarding/')({
  component: OnboardingPage,
});

function OnboardingPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useUserMe();

  // Get the first relationship (creator always has one)
  const relationship = data?.relationships?.[0];

  // Check if user is creator with active relationship (partner accepted)
  const hasActiveRelationship =
    relationship && relationship.guest_user_id !== null;

  // Redirect to home if user has active relationship
  if (hasActiveRelationship) {
    navigate({ to: '/home' });
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center">
        <LoadingState message="Carregando..." />
      </div>
    );
  }

  // If no relationship yet, something is wrong - redirect to home
  if (!relationship) {
    navigate({ to: '/home' });
    return null;
  }

  // Show invite link card for creators waiting for partner
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 py-8">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <Link to="/" className="inline-block">
            <LogoText className="text-4xl" />
          </Link>
        </div>

        <div className="space-y-6 text-center">
          <div className="bg-primary/10 mx-auto flex h-20 w-20 items-center justify-center rounded-full">
            <Heart className="text-primary h-10 w-10" />
          </div>
          <div className="space-y-2">
            <h1 className="text-2xl font-semibold tracking-tight">
              Conecte-se com seu amor
            </h1>
            <p className="text-muted-foreground">
              Compartilhe o link abaixo com seu parceiro(a) para começarem a
              usar o eumimo juntos
            </p>
          </div>
        </div>

        <InvitePartnerForm inviteToken={relationship.invite_token} />

        <div className="text-center">
          <Link
            to="/home"
            className="text-muted-foreground hover:text-primary text-sm"
          >
            Ir para o início
          </Link>
        </div>
      </div>
    </div>
  );
}
